import { orderIsFreeShippingEligible } from "../../utils/orderIsFreeShippingEligible";
import { ViewOrderInvoiceCTA } from "./ctas";
export var DidNotGetInsiderFreeShippingIA = function DidNotGetInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  return ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return undefined;
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
var ORDER_IS_FREE_SHIPPING_INELIGIBLE = function ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var ORDER_IS_FREE_SHIPPING_ELIGIBLE = function ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING = function WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "AFUJpc",
    defaultMessage: [{
      "type": 0,
      "value": "Porque não tive envio gratuito com Insider na minha encomenda?"
    }]
  });
};
var INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "n75Vyn",
    defaultMessage: [{
      "type": 0,
      "value": "É importante salientar que tem acesso a envios gratuitos em marcas selecionadas com a sua subscrição Insider. Embora este benefício não seja aplicável em todo o marketplace, pode identificar facilmente as marcas elegíveis enquanto navega na Faire. Só tem de prestar atenção às marcas assinaladas com \"Envio gratuito com Insider\" e um símbolo de chave azul. Além disso, se a sua subscrição Insider cobrir o custo de envio numa determinada marca, essa informação será indicada no check-out. Se a subscrição não cobrir uma marca, o custo de envio é apresentado como \"Por confirmar\" ou é apresentada uma estimativa do custo de envio."
    }]
  });
};
var ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING = function ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HkpAbF",
    defaultMessage: [{
      "type": 0,
      "value": "A encomenda que selecionou deve ser elegível para envio gratuito com Insider. Para confirmar se o envio gratuito com Insider foi aplicado a esta encomenda, aceda ao separador \"Faturas\" no portal da Faire e encontre a fatura correspondente. Verifique a linha de custos de envio. Esta deve indicar claramente que o envio gratuito com Insider foi aplicado a esta encomenda. Se não vir esta mensagem, contacte a nossa equipa de apoio para obter assistência adicional."
    }]
  });
};